/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectPGAEventQueryVariables = {||};
export type SelectPGAEventQueryResponse = {|
  +eventsForLiveScorecard: ?$ReadOnlyArray<?{|
    +id: string,
    +tournament: {|
      +officialName: string
    |},
  |}>
|};
export type SelectPGAEventQuery = {|
  variables: SelectPGAEventQueryVariables,
  response: SelectPGAEventQueryResponse,
|};
*/


/*
query SelectPGAEventQuery {
  eventsForLiveScorecard {
    id
    tournament {
      officialName
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectPGAEventQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "eventsForLiveScorecard",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectPGAEventQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "eventsForLiveScorecard",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb12c42bdcaebd9f994ec3cc20afd19f",
    "id": null,
    "metadata": {},
    "name": "SelectPGAEventQuery",
    "operationKind": "query",
    "text": "query SelectPGAEventQuery {\n  eventsForLiveScorecard {\n    id\n    tournament {\n      officialName\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '143d4871c0d60c4845e6fed601512bfc';

module.exports = node;
